import React, { DetailedHTMLProps, FormHTMLAttributes, JSX } from 'react';

/**
 * Simple Form wrapper that adds some defaults to the form
 *
 * - Added action="#" as this will trigger to add the blue enter button on mobile devices keyboard
 */
export default function Form({ children, ...props }: DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>): JSX.Element {
  return (
    <form action='#' {...props}>
      {children}
    </form>
  );
}
